// all other functions that relate to invoices live here

import { fillLookupValuesByPropertyNames, getLookupDescription } from "@modernary/mui/components/lookup";
import type { Invoice, InvoiceNew } from "./invoice";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};

function addAuthRequestFields(entity: Invoice) {
  entity._authRequestFields = ["id", "statusMurn"];
  return entity;
}

function getInitialData() {
  const result = {} as Invoice; //TODO: ts
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Invoice }) {
  await fillLookupValuesByPropertyNames(response.data, ["typeMurn", "statusMurn"]);
  addAuthRequestFields(response.data);

  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Invoice }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function requestAdapter(data: Invoice) {
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit<T extends Invoice | InvoiceNew>(data: T) {}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: Invoice) {}
